// src/api/loadingStore.js
// -----------------------------------------------------------------------------
// Pub/Sub store to track outstanding HTTP request counts across the app.
// Allows non-React code (like Axios client interceptors) to publish events
// that React context providers can subscribe to.
// -----------------------------------------------------------------------------

let count = 0;
let currentMessage = 'Processing request...';
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(count, currentMessage);
    } catch (e) {
      console.error('Error in loadingStore listener:', e);
    }
  });
}

export const loadingStore = {
  increment(message) {
    count++;
    if (message && typeof message === 'string') {
      currentMessage = message;
    }
    notify();
  },

  decrement() {
    count = Math.max(0, count - 1);
    if (count === 0) {
      currentMessage = 'Processing request...';
    }
    notify();
  },

  show(message) {
    this.increment(message);
  },

  hide() {
    this.decrement();
  },

  reset() {
    count = 0;
    currentMessage = 'Processing request...';
    notify();
  },

  subscribe(listener) {
    listeners.add(listener);
    // Fire immediately with initial value
    listener(count, currentMessage);
    return () => {
      listeners.delete(listener);
    };
  },

  getCount() {
    return count;
  },

  getMessage() {
    return currentMessage;
  },
};

export default loadingStore;

